(function($){
   window.theme = window.theme || {};

   theme.playAudioButton = {
      init: function(){
         $('.grid-product__play').on('click', this.playButtonCallback);
         $('.homepage_play_button').on('click', this.playButtonHomepage);
      },
 
      playButtonHomepage: function(e){
         e.preventDefault();
         $(this).hide();
         $('#audiplayer_home_container').fadeIn();
         $('#audiplayer_home_container').find('.audio_player')[0].play();
      },

      playButtonCallback: function(e){
         e.preventDefault();
         $(this).hide();
         $(this).parent().find('#audio_player_container').fadeIn();
         $(this).parent().find('.audio_player')[0].play();
      }
   };

   theme.mobileNavigation ={
      init: function(){
         $('.menu-dropdown-toggle').on('click', this.menuToggle);
         $('.burger-menu').on('click', this.burgerMenuAction);
      },

     menuToggle: function(e){
       e.preventDefault();
       $(this).parent().parent().toggleClass('open');
     },
     
     burgerMenuAction: function(e){
         e.preventDefault();
         $(this).toggleClass('open');
         $('.site-nav-container').slideToggle();
      }
   };

   theme.ProductRecommendations = function(container) {
      this.$container = $(container);
   
      var baseUrl = this.$container.data('baseUrl');
      var productId = this.$container.data('productId');
      var recommendationsSectionUrl =
         baseUrl +
         '?section_id=product-recommendations&product_id=' +
         productId +
         '&limit=3';
   
      $.get(recommendationsSectionUrl).then(
         function(section) {
         var recommendationsMarkup = $(section).html();
         if (recommendationsMarkup.trim() !== '') {
            this.$container.html(recommendationsMarkup);
            theme.addToCartButton.init();
            theme.playAudioButton.init();
         }
         }.bind(this)
      );
   };

   theme.addToCartButton = {
      loading: false,

      init: function(){
         $('.atc-button').on('click', this.addToCart);
      },

      addToCart: function(e){
         e.preventDefault();
         var $button = $(this);

         if ( theme.addToCartButton.loading === true) {
            return false;
         }

         var data = {
            items: [
               {
                id: $(this).data('product_id'),
                quantity: 1
               }
             ]
         };
         
         $button.fadeTo('fast', .5);
         theme.addToCartButton.loading = true;
         $.post(window.Shopify.routes.root + 'cart/add.js', data, function(response){
            theme.addToCartButton.loading = false;
            $button.fadeTo('fast', 1);
            location.href = window.Shopify.routes.root + 'cart';
         }, 'JSON');
      }
   };

   theme.desktopSearchButton = {
      init: function(){
         $('.desktop-search-button').on('click', this.showSearchBox);
         $('.search-input').on('blur', this.hideSearchBox);
      },

      showSearchBox: function (e){
         e.preventDefault();
         let $container = $('.float-search__container');
         $container.toggle();
         $container.find('.search-input').focus();
      },

      hideSearchBox: function(e){
         console.log('Blur');
         setTimeout(function(){
            $('.float-search__container').hide();
         }, 500);
      }
   };

   theme.sortBy = {
      init: function(){
         $('.sortby_list__link').on('click', this.sortAction);
         $('.product--grid-sort-button').on('click', this.showOptions);
         $(document).on("click", this.onBlur);
      },

      sortAction: function(e){
         e.preventDefault();
         var sortValue = $(this).data('value');
         //var url = $(this).attr('href');
        var url = window.location.href;
        
          if ( url.includes('sort_by')){
			url = url.replace('price-ascending', sortValue);
            url = url.replace('price-descending', sortValue);
            url = url.replace('title-ascending', sortValue);
            url = url.replace('title-descending', sortValue);
            url = url.replace('created-ascending', sortValue);
            url = url.replace('created-descending', sortValue);
          } else if ( url.includes('?')){
            url += '&sort_by=' + sortValue;
         } else {
            url += '?sort_by=' + sortValue;
         }

         location.href = url;
      },

      showOptions: function(e){
         e.preventDefault();
         $('.sortby_list').slideToggle();
      },

      onBlur: function(e){
         console.log('Target', $(e.target));
         if ( $(e.target).closest('.sortby_list').length === 0 && $(e.target).closest('.product--grid-sort-button').length === 0) {
            $('.sortby_list').slideUp();
            console.log('Outside');
         }
      }
   };

   theme.account = {
      init: function(){
         $('#RecoverPassword').on('click', this.showRecoverPassword);
         $('#HideRecoverPasswordLink').on('click', this.hideRecoverPassword);
      },

      showRecoverPassword: function(e){
         e.preventDefault();
         $('#CustomerLoginForm').hide();
         $('#RecoverPasswordForm').fadeIn();
      },

      hideRecoverPassword: function(e){
         e.preventDefault();
         $('#RecoverPasswordForm').hide();
         $('#CustomerLoginForm').fadeIn();
      }
   };

   theme.lightBox = {
      init: function(){
         $('.light-box-button').simpleLightbox();
      }
   };

   theme.pageFlyTweaks = {
      
      initReadMore: function(){
         $('.pf-read-more').on('blur', function(){
            console.log('Text', $(this).text());
            if ( $(this).text() === 'Less') {
               console.log('Lesss');
            }
            setTimeout(function(){
               theme.pageFlyTweaks.initReadMore();

            }, 1000);
         });
      }
   };

   $(document).ready(function(){
      theme.mobileNavigation.init();
      theme.addToCartButton.init();
      theme.playAudioButton.init();
      theme.ProductRecommendations('.product-recommendations');
      theme.desktopSearchButton.init();
      theme.sortBy.init();
      theme.account.init();
      theme.lightBox.init();
      theme.pageFlyTweaks.initReadMore();

      $('.play-button-icon').on('click', function(){
         var $iframe = $('.slbIframe');
         var iframeURL = $iframe.attr('src');
         iframeURL= iframeURL.replace('modestbranding=1', 'modestbranding=0');
         iframeURL= iframeURL.replace('controls=1', 'controls=0');
         $iframe.attr('src', iframeURL);

         console.log('IFrame', $iframe.attr('src'));
      })
   });
})(jQuery); 